var hasPickupStore = function hasPickupStore() {
  var deliveryTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return deliveryTypes.find(function (el) {
    return ['store_pickup', 'pickup_point'].includes(el.type);
  });
};
export default hasPickupStore;